import { api } from "@/lib/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getGuideQueryOptions, getGuidesQueryOptions } from "./get.hooks";

export function useDeleteGuide(opts?: {
  onSuccess?: () => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (id: string) =>
      api.delete<void>(`/api/guides/$id`, undefined, {
        pathReplace: { $id: id },
      }),
    onSuccess: (_, id) => {
      queryClient.setQueryData(getGuidesQueryOptions.queryKey, (old) =>
        old?.filter((g) => g.id !== id),
      );
      queryClient.resetQueries({ queryKey: getGuideQueryOptions(id).queryKey });
      toast({
        title: "toast.guideDeleted",
        variant: "success",
      });
      opts?.onSuccess?.();
    },
    onError: () => {
      toast({
        title: "toast.deleteGuideError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
